const ThePipsInsightsContentFour = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="contact__cards row">
          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Timely Market Analysis</h4>
              </div>
              <p>
                Get daily and weekly updates on market trends, price movements,
                and technical indicators that matter most.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Expert Opinions</h4>
              </div>
              <p>
                Access professional commentary from analysts who combine market
                experience with academic precision.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Data Visualization Tools</h4>
              </div>
              <p>
                Understand trends better with charts, infographics, and visual
                reports designed for clarity and quick interpretation.
              </p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12 mb-4">
            <div className="contact__card">
              <div className="card-header">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/markets/instant_withdrawals.png"
                  }
                  alt="play icon"
                />
                <h4>Multi-Market Focus</h4>
              </div>
              <p>
                From currencies to commodities, gain insights that reflect the
                full scope of today’s interconnected markets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThePipsInsightsContentFour;
